export enum Locales {
  OTHER = 'OTHER',
  US = 'US',
  UA = 'UA',
  AE = 'AE',
  AL = 'AL',
  AT = 'AT',
  AU = 'AU',
  BG = 'BG',
  BE = 'BE',
  CA = 'CA',
  CH = 'CH',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DK = 'DK',
  GB = 'GB',
  GR = 'GR',
  IE = 'IE',
  IT = 'IT',
  IS = 'IS',
  ME = 'ME',
  HR = 'HR',
  HU = 'HU',
  EE = 'EE',
  ES = 'ES',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  MK = 'MK',
  MT = 'MT',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  RS = 'RS',
  SI = 'SI',
  SK = 'SK',
  FI = 'FI',
  FR = 'FR',
  SE = 'SE',
  MX = 'MX',
  ZA = 'ZA',
  NZ = 'NZ',
  CN = 'CN',
  SG = 'SG',
  HK = 'HK',
  JP = 'JP',
  TW = 'TW',
  TR = 'TR',
  KR = 'KR',
  ID = 'ID',
  IL = 'IL',
  NG = 'NG',
  BR = 'BR',
  AR = 'AR',
  IN = 'IN',
  PE = 'PE',
  DZ = 'DZ',
  EG = 'EG',
  LY = 'LY',
  MA = 'MA',
  SD = 'SD',
  TN = 'TN',
  EH = 'EH',
  AO = 'AO',
  BJ = 'BJ',
  BW = 'BW',
  IO = 'IO',
  BF = 'BF',
  BI = 'BI',
  CV = 'CV',
  CM = 'CM',
  CF = 'CF',
  TD = 'TD',
  KM = 'KM',
  CG = 'CG',
  CD = 'CD',
  CI = 'CI',
  DJ = 'DJ',
  GQ = 'GQ',
  ER = 'ER',
  SZ = 'SZ',
  ET = 'ET',
  TF = 'TF',
  GA = 'GA',
  GM = 'GM',
  GH = 'GH',
  GN = 'GN',
  GW = 'GW',
  KE = 'KE',
  LS = 'LS',
  LR = 'LR',
  MG = 'MG',
  MW = 'MW',
  ML = 'ML',
  MR = 'MR',
  MU = 'MU',
  YT = 'YT',
  MZ = 'MZ',
  NA = 'NA',
  NE = 'NE',
  RE = 'RE',
  RW = 'RW',
  SH = 'SH',
  ST = 'ST',
  SN = 'SN',
  SC = 'SC',
  SL = 'SL',
  SO = 'SO',
  SS = 'SS',
  TZ = 'TZ',
  TG = 'TG',
  UG = 'UG',
  ZM = 'ZM',
  ZW = 'ZW',
  AI = 'AI',
  AG = 'AG',
  AW = 'AW',
  BS = 'BS',
  BB = 'BB',
  BZ = 'BZ',
  BO = 'BO',
  BQ = 'BQ',
  BV = 'BV',
  KY = 'KY',
  CL = 'CL',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CW = 'CW',
  DM = 'DM',
  DO = 'DO',
  EC = 'EC',
  SV = 'SV',
  FK = 'FK',
  GF = 'GF',
  GD = 'GD',
  GP = 'GP',
  GT = 'GT',
  GY = 'GY',
  HT = 'HT',
  HN = 'HN',
  JM = 'JM',
  MQ = 'MQ',
  MS = 'MS',
  NI = 'NI',
  PA = 'PA',
  PY = 'PY',
  PR = 'PR',
  BL = 'BL',
  KN = 'KN',
  LC = 'LC',
  MF = 'MF',
  VC = 'VC',
  SX = 'SX',
  GS = 'GS',
  SR = 'SR',
  TT = 'TT',
  TC = 'TC',
  UY = 'UY',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  AN = 'AN',
  AQ = 'AQ',
  KP = 'KP',
  RU = 'RU',
  BN = 'BN',
  KH = 'KH',
  LA = 'LA',
  MY = 'MY',
  MM = 'MM',
  PH = 'PH',
  TH = 'TH',
  TL = 'TL',
  VN = 'VN',
  AF = 'AF',
  BD = 'BD',
  BT = 'BT',
  IR = 'IR',
  MV = 'MV',
  NP = 'NP',
  PK = 'PK',
  LK = 'LK',
  PS = 'PS',
  BH = 'BH',
  IQ = 'IQ',
  JO = 'JO',
  LB = 'LB',
  OM = 'OM',
  SY = 'SY',
  YE = 'YE',
  FJ = 'FJ',
  NC = 'NC',
  PG = 'PG',
  SB = 'SB',
  VU = 'VU',
  GU = 'GU',
  KI = 'KI',
  MH = 'MH',
  FM = 'FM',
  NR = 'NR',
  MP = 'MP',
  PW = 'PW',
  UM = 'UM',
  AS = 'AS',
  CK = 'CK',
  PF = 'PF',
  NU = 'NU',
  PN = 'PN',
  WS = 'WS',
  TK = 'TK',
  TO = 'TO',
  TV = 'TV',
  WF = 'WF',
  SA = 'SA',
  KW = 'KW',
  QA = 'QA',
  KZ = 'KZ',
  GE = 'GE',
  AM = 'AM',
  AZ = 'AZ',
  KG = 'KG',
  UZ = 'UZ',
  TJ = 'TJ',
  TM = 'TM',
  BY = 'BY',
  MD = 'MD',
  BA = 'BA',
  MN = 'MN',
  MO = 'MO',
  AD = 'AD',
  MC = 'MC',
  SM = 'SM',
  VA = 'VA',
  AX = 'AX',
  FO = 'FO',
  GL = 'GL',
  GI = 'GI',
  IM = 'IM',
  JE = 'JE',
  GG = 'GG',
  BM = 'BM',
  CC = 'CC',
  CX = 'CX',
  HM = 'HM',
  NF = 'NF',
  PM = 'PM',
  SJ = 'SJ',
}
